import React, { ChangeEvent, FunctionComponent } from 'react';
import { Controller } from 'react-hook-form';

import { FormGroup, InputFormat, Message } from 'components/chroma';

import { InputFormatQuestionProps } from 'scenes/common/components/Questions/types';
import styled from 'styled-components';
import { RedText } from '../InputQuestion/InputQuestion';

type HelperTextWrapperProps = {
  reduceMargin: boolean;
};
const ReducedFormGroupMargin = styled.div`
  ${(props: HelperTextWrapperProps) =>
    props.reduceMargin &&
    `.p-form-group {
      margin: 0px 0px 0.75rem;
    }`};
}`;

const InputFormatQuestion: FunctionComponent<InputFormatQuestionProps> = ({
  errors,
  prefix,
  control,
  question,
  stateKey,
  changeHandler,
  helpText,
  defaultValue,
  validationRules,
  format,
  mask,
  ariaLabel,
  maxLength,
  helpLink,
  helpInfo,
  placeholder,
  autoCompleteName,
  isNumericString,
  type,
  inputMode,
  decimalScale,
  allowEmptyFormatting,
  ariaRequired,
  ariaLabelledBy,
  ariaDescribedBy,
  nonClickableHelpText,
}) => (
  <Controller
    control={control}
    name={stateKey}
    defaultValue={defaultValue}
    rules={validationRules}
    render={({ onChange, value }) => (
      <>
        <ReducedFormGroupMargin reduceMargin={!!nonClickableHelpText}>
          <FormGroup
            id={stateKey}
            label={question}
            error={errors[stateKey]?.message || ''}
            helpText={helpText || ''}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...(helpLink && { helpLink })}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...(helpInfo && { helpLink: { ...helpInfo, onClick: () => {} } })}
          >
            <InputFormat
              data-testid={stateKey}
              id={stateKey}
              value={value}
              name={stateKey}
              aria-labelledby={ariaLabelledBy}
              format={format}
              mask={mask}
              prefix={prefix}
              maxLength={maxLength}
              ariaLabel={ariaLabel}
              aria-required={ariaRequired}
              placeholder={placeholder ?? ''}
              autoComplete={autoCompleteName}
              isNumericString={isNumericString}
              decimalScale={decimalScale}
              type={type}
              inputMode={inputMode}
              helpInfo={helpInfo}
              allowEmptyFormatting={allowEmptyFormatting}
              valid={Boolean(value) && !errors[stateKey]}
              error={Boolean(value) && Boolean(errors[stateKey])}
              onChange={(event: ChangeEvent<HTMLInputElement>) =>
                changeHandler ? changeHandler(event, onChange) : onChange(event)
              }
              // eslint-disable-next-line jsx-a11y/aria-props
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...(ariaDescribedBy && { 'aria-describedby': ariaDescribedBy })}
            />
          </FormGroup>
        </ReducedFormGroupMargin>
        {nonClickableHelpText && (
          <Message margin={{ bottom: 6 }} info>
            <RedText id={ariaDescribedBy}>{nonClickableHelpText}</RedText>
          </Message>
        )}
      </>
    )}
  />
);

export default InputFormatQuestion;
